import { FormLabel, styled } from '@mui/material'

export const TextFieldLabel = styled(FormLabel)`
  display: block;
  font-weight: 500;
  font-size: ${(props) => props.theme.typography.pxToRem(12)};
  color: ${(props) => props.theme.palette.text.primary};
  margin-bottom: ${(props) => props.theme.typography.pxToRem(4)};
  line-height: 1.5;
`